import { type AdminPaymentsPage, type AdminPlan, type UpdatePlanBody } from '@/contracts';

import { authenticated } from '../auth-client';
import { API_PREFIX } from '../http';

export const billingEndpoints = {
  plans() {
    return authenticated<AdminPlan[]>(`${API_PREFIX}/admin/plans`);
  },

  updatePlan(planId: string, body: UpdatePlanBody) {
    return authenticated<AdminPlan>(`${API_PREFIX}/admin/plans/${planId}`, {
      method: 'PUT',
      body,
    });
  },

  payments(params: Record<string, string> = {}) {
    const query = new URLSearchParams(params).toString();
    return authenticated<AdminPaymentsPage>(
      `${API_PREFIX}/admin/payments${query ? `?${query}` : ''}`,
    );
  },
};
